<template>
  <div id="welcome-page">
    <div class="header-welcome">
      <div class="profile-image">
        <img 
          :src="`http://gitlab.meta.com.br/uploads/-/system/user/avatar/${$root.usuario('id_gitlab')}/avatar.png`" 
          onerror="this.src='img/default-user.png'" 
        />
      </div>
      <div class="informations">
        <h1 style="margin-bottom: 25px;">{{ $root.usuario('user_name') }}</h1>
        <h4 v-if="indicador">
          Você apontou 
          <strong :class="getClassColor(calculaPorcentagem(indicador))">{{ calculaPorcentagem(indicador) }}%</strong> 
          das suas horas essa semana!</h4>
        <div class="progress-item" v-if="indicador">
          <progress-bar :total="indicador.total" :current="indicador.duracao"></progress-bar>
          <div>{{ getDuracao(indicador.duracao) }} de {{ getDuracao(indicador.total) }}</div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="row">
        <div class="col-lg-12">
          <horas-competencia></horas-competencia>
        </div>
      </div>
    </div>
    <div class="body" v-if="$root.isGestor || $root.isAdmin">
      <div class="row">
        <div class="col-lg-12">
          <indicador-equipe></indicador-equipe>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#welcome-page {
  .header-welcome {
    box-shadow: 0px 0px 4px -1px black;
    background-color: #ffffff96;
    margin-top: -1.5rem;
    margin-right: -30px;
    margin-left: -30px;
    display: flex;
    flex-direction: row;
    padding: 30px;

    .profile-image {
      min-width: 250px;
      min-height: 200px;
      border-right: 1px solid rgb(159, 159, 159);
      margin-right: 48px;

      img {
        border-radius: 100%;
        border: 1px solid rgb(159, 159, 159);
        width: 200px;
        height: 200px;
      }
    }

    & .green {
      color: #1BB05E;
    }

    & .yellow {
      color: #F7A01B;
    }

    & .red {
      color: #BD3834;
    }
  }

  .body {
    padding: 30px 0; 
  }
}
</style>

<script>
import Uteis from '@/mixins/utils.js';
import IndicadorEquipe from '@/components/indicadores/Equipe';
import HorasCompetencia from '@/components/indicadores/HorasCompetencia';
import ProgressBar from '@/components/templates/ProgressBar';
import moment from 'moment';

export default {
  mixins: [
    Uteis,
  ],

  components: {
    IndicadorEquipe,
    ProgressBar,
    HorasCompetencia,
  },

  data() {
    return {
      indicador: null,
    };
  },

  mounted() {
    this.buscarIndicadores();
  },

  computed: {
    fimPeriodo() {
      const data = new Date().toISOString().slice(0,10);
      return new Date(`${data} 09:00:00`);
    },
  },

  methods: {
    async buscarIndicadores() {
      try {
        const { data: response } = await this.$http.get(`/dashboard/usuario/apontamentos`, {
          params: {
            dt_inicio: moment().subtract(6, 'days').format('YYYY-MM-DD'),
            dt_fim: moment().format('YYYY-MM-DD'),
          }
        });

        const registro = response.registro ? response.registro : null;

        if (registro) {
          const periodoExecutado = this.getPeriodoExecutado(registro.horas_liberadas);

          registro.total = (registro.horas_liberadas * 4) + periodoExecutado;
          this.indicador = registro;
        }
      } catch(e) {
        console.error(e);
      }
    },

    calculaPorcentagem(indicador) {
      return ((indicador.duracao * 100) / indicador.total).toFixed(0);
    },

    getClassColor(porcentagem) {
      if (porcentagem <= 110 && porcentagem >= 90) {
        return 'green';
      }

      return porcentagem < 90 && porcentagem >= 80 ? 'yellow' : 'red';
    },

    getFolgasEntrePeriodos(inicial = 0) {
      // Não contabiliza dia completo atual
      let folgas = inicial;

      for(let i = 0; i < this.diferencaDatas; i++) {
        const data = this.removerDias(new Date(), i);
        const diaSemana = new Date(data).getDay();

        if (diaSemana === 0 || diaSemana === 6) {
          folgas++;
        }
      }

      return folgas;
    },
    getPeriodoExecutado(horasLiberadas) {
      const diaSemana = new Date().getDay();
      const hora = new Date().getHours();

      if (diaSemana === 0 || diaSemana === 6) {
        return 0;
      }

      const percorrido = (Math.abs(new Date(this.fimPeriodo) - new Date()) / 36e5);

      if (hora >= (10 + (horasLiberadas / 3600))) {
        return horasLiberadas;
      }

      return (hora > 12 ? percorrido - 1 : percorrido) * 3600;
    },
  },
}
</script>

